import React, { useMemo, useState } from 'react';
import ActionMenu from './ActionMenu';
import AppIcon from './AppIcon';
import WorkspaceState from './WorkspaceState';

function VaultView({ apps, onAdd, onEdit, onMove, onDelete }) {
  const [query, setQuery] = useState('');
  const sortedApps = useMemo(() => {
    const normalized = query.trim().toLocaleLowerCase();
    return apps
      .filter((app) => !normalized
        || app.name.toLocaleLowerCase().includes(normalized)
        || app.note.toLocaleLowerCase().includes(normalized))
      .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' })
        || a.id.localeCompare(b.id));
  }, [apps, query]);

  return (
    <section className="vault" aria-labelledby="vault-title">
      <div className="vault-heading">
        <div>
          <h1 id="vault-title">Vault</h1>
          <p>Tools you've saved for later.</p>
        </div>
        {apps.length > 0 && (
          <button type="button" className="btn btn-primary" onClick={onAdd}>Add tool</button>
        )}
      </div>

      {apps.length > 8 && (
        <label className="vault-search-label">
          <span className="sr-only">Search Vault</span>
          <input
            className="vault-search"
            type="search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search tools"
          />
        </label>
      )}

      {apps.length === 0 ? (
        <WorkspaceState
          title="No tools saved yet"
          text="Keep tools here until you need them."
          actionLabel="Add tool"
          onAction={onAdd}
        />
      ) : sortedApps.length === 0 ? (
        <p className="vault-empty-result" role="status">No tools match your search.</p>
      ) : (
        <div className="vault-list">
          {sortedApps.map((app) => (
            <div className="vault-row" key={app.id}>
              <a
                className="vault-link"
                href={app.url}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={`Open ${app.name} in a new tab`}
              >
                <AppIcon app={app} />
                <span className="vault-copy">
                  <span className="vault-name">{app.name}</span>
                  {app.note && <span className="vault-note">{app.note}</span>}
                </span>
              </a>
              <ActionMenu
                label={`Options for ${app.name}`}
                items={[
                  { label: 'Edit', onSelect: () => onEdit(app) },
                  { label: 'Move to Apps', onSelect: () => onMove(app) },
                  { label: 'Delete', onSelect: () => onDelete(app), danger: true }
                ]}
              />
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default VaultView;